// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._4N2AFChQx{overflow:hidden}._1RbGnWeRx{overflow:auto;max-height:calc(100vh - 85px - 120px)}.v4QFIzPMx ._1RbGnWeRx{max-height:calc(100vh - 85px - 80px - 120px)}._2XGPXNDDx ._1RbGnWeRx{height:calc(100vh - 85px - 120px)}._2XGPXNDDx.v4QFIzPMx ._1RbGnWeRx{height:calc(100vh - 85px - 80px - 120px)}\n", "",{"version":3,"sources":["webpack://client/shared/dialog/scrollable-dialog.scss"],"names":[],"mappings":"AAAA,YAAmB,eAAe,CAAC,YAAkB,aAAa,CAAC,qCAAqC,CAAC,uBAAmC,4CAA4C,CAAC,wBAA+B,iCAAiC,CAAC,kCAA+C,wCAAwC","sourcesContent":[".scrollable-dialog{overflow:hidden}.scroll-container{overflow:auto;max-height:calc(100vh - 85px - 120px)}.with-bottom-bar .scroll-container{max-height:calc(100vh - 85px - 80px - 120px)}.full-height .scroll-container{height:calc(100vh - 85px - 120px)}.full-height.with-bottom-bar .scroll-container{height:calc(100vh - 85px - 80px - 120px)}:export{topBarHeight:85px;bottomBarHeight:80px}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topBarHeight": "85px",
	"bottomBarHeight": "80px",
	"scrollable-dialog": "_4N2AFChQx",
	"scrollableDialog": "_4N2AFChQx",
	"scroll-container": "_1RbGnWeRx",
	"scrollContainer": "_1RbGnWeRx",
	"with-bottom-bar": "v4QFIzPMx",
	"withBottomBar": "v4QFIzPMx",
	"full-height": "_2XGPXNDDx",
	"fullHeight": "_2XGPXNDDx"
};
export default ___CSS_LOADER_EXPORT___;
